import { createViewSettings } from "@/ui/views";
import type { TCompositionDeps } from "./types";

/**
 * Platform settings: the user's own settings modal. Customer-module settings
 * pages (master data, books, company settings) are wired by their module.
 */
export const wireSettings = (_deps: TCompositionDeps) => {
    const ViewSettings = createViewSettings();
    return { ViewSettings };
};
